import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/lib/auth";
import { CartProvider } from "@/lib/cart";
import { I18nProvider } from "@/lib/i18n";
import SmoothScroll from "@/components/SmoothScroll";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Story from "@/pages/Story";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import { Checkout, PaymentSuccess, PaymentCancel } from "@/pages/Checkout";
import { Login, Register } from "@/pages/Auth";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import GiftCard from "@/pages/GiftCard";
import Review from "@/pages/Review";
import GiftCardSuccess from "@/pages/GiftCardSuccess";
import CampaignBanner from "@/components/CampaignBanner";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <CartProvider>
          <HelmetProvider>
          <BrowserRouter>
            <SmoothScroll>
              <div className="App grain">
                <ScrollToTop />
                <CampaignBanner />
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/product/:slug" element={<Product />} />
                    <Route path="/story" element={<Story />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/gift-card" element={<GiftCard />} />
                    <Route path="/bewertung" element={<Review />} />
                    <Route path="/gift-card/success" element={<GiftCardSuccess />} />
                    <Route path="/impressum" element={<Legal />} />
                    <Route path="/datenschutz" element={<Legal />} />
                    <Route path="/agb" element={<Legal />} />
                    <Route path="/widerruf" element={<Legal />} />
                    <Route path="/legal/:slug" element={<Legal />} />
                  </Routes>
                </main>
                <Footer />
                <CartDrawer />
                <CookieBanner />
                <Toaster theme="dark" position="bottom-right" toastOptions={{
                  style: { background: "#0A0A0A", border: "1px solid #C9A24C33", color: "#F5EFE1", fontFamily: "Manrope", borderRadius: 0 },
                }} />
              </div>
            </SmoothScroll>
          </BrowserRouter>
          </HelmetProvider>
        </CartProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
